import { api } from '@rd-web-markets/shared/dist/services/service';

const trackingTaskAttachmentService = {
  all: (claimProjectReportId, trackingTaskId) => api.get(`/time_tracking/claim_project_reports/${claimProjectReportId}/tracking_tasks/${trackingTaskId}/tracking_task_attachments/`),
  create: (claimProjectReportId, trackingTaskId,  formData) => api.postFormData(`/time_tracking/claim_project_reports/${claimProjectReportId}/tracking_tasks/${trackingTaskId}/tracking_task_attachments/`, formData),
  delete: (claimProjectReportId, trackingTaskId, documentId) => api.delete(`/time_tracking/claim_project_reports/${claimProjectReportId}/tracking_tasks/${trackingTaskId}/tracking_task_attachments/${documentId}`),
}

export default trackingTaskAttachmentService;